import { render, staticRenderFns } from "./BalancePayoneerHistoryTable.vue?vue&type=template&id=74ba27b2&scoped=true"
import script from "./BalancePayoneerHistoryTable.vue?vue&type=script&lang=js"
export * from "./BalancePayoneerHistoryTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ba27b2",
  null
  
)

export default component.exports